<template>
    <div class="request-appointment-at-invite">
        <div class="card">
            <common-user-avatar :user="joinInviteAsInviteConnection" size="member-switch"></common-user-avatar>
            <span class="email">{{ joinInvite.toEmail }}</span>
            <span class="role">{{ roleNameForDisplay }}</span>
            <network-inclusion-status
                :isInMyNetwork="true"
                :targetType="targetType"
                :targetId="joinInvite.id"
            ></network-inclusion-status>
        </div>
        <span class="text">
            {{ $t('elements.network.request_appointment_at_join_invite.unfortunately') }} {{ joinInvite.toEmail }}
            {{ $t('elements.network.request_appointment_at_join_invite.has_not_yet_accepted') }}
        </span>
        <div class="text-area-wrapper">
            <span class="text-area-label">
                {{ $t('elements.network.request_appointment_at_join_invite.type_a_message_for') }} {{ joinInvite.toEmail }}
            </span>
            <textarea-input
                :placeholder="$t('elements.network.request_appointment_at_join_invite.text_area_placeholder')"
                @change="emailTextChanged"
            ></textarea-input>
        </div>
        <common-button
            :label="$t('elements.network.request_appointment_at_join_invite.buttons.send')"
            type="primary"
            size="large"
            @click="sendClicked"
        ></common-button>
    </div>
</template>

<script>
    import NetworkInclusionStatus from './NetworkInlusionStatus'
    import TextareaInput from 'components/form-inputs/TextareaInput'
    import UsersAPI from 'api/UsersAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            TextareaInput,
            NetworkInclusionStatus,
        },
        props: {
            joinInvite: { type: Object, required: true },
        },
        data() {
            return {
                emailText: '',
            }
        },
        computed: {
            targetType() {
                return this.joinInviteAsInviteConnection.target.type
            },
            joinInviteAsInviteConnection() {
                return {
                    name: this.joinInvite.toEmail,
                    connectionType: 1,
                    practiceType: this.isPhysician ? 2 : 3,
                    target: {
                        id: this.joinInvite.id,
                        name: this.joinInvite.toEmail,
                        type: this.isPhysician ? PracticeTypeEnum.USER : PracticeTypeEnum.ANCILLARY,
                    },
                }
            },
            roleNameForDisplay() {
                return this.isPhysician
                    ? this.$t('elements.network.request_appointment_at_join_invite.role_physician')
                    : this.$t('elements.network.request_appointment_at_join_invite.role_ancillary')
            },
            isPhysician() {
                return this.joinInvite.practiceType === 'physician'
            },
        },
        methods: {
            emailTextChanged(newValue) {
                this.emailText = newValue
            },
            sendClicked() {
                let trimmedEmailText = this.emailText ? this.emailText.trim() : null

                if (trimmedEmailText)
                    UsersAPI.sendReminderForJoinInvite(
                        this.$auth.getActiveMember().id,
                        this.joinInvite.id,
                        'referral',
                        this.emailText,
                    ).then(() => this.$emit('emailSent', {}))
            },
        },
    }
</script>

<style scoped>
    .request-appointment-at-invite {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 400;
    }
    .request-appointment-at-invite > .card {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .request-appointment-at-invite > .card > .email {
        font-size: 22px;
        font-weight: 500;
        margin-top: 30px;
    }

    .request-appointment-at-invite > .card > .role {
        font-size: 20px;
        font-weight: 300;
        margin-bottom: 15px;
    }

    .request-appointment-at-invite > .text {
        font-size: 18px;
        margin-top: 25px;
        margin-bottom: 20px;
        text-align: center;
    }

    .request-appointment-at-invite > .text-area-wrapper {
        font-size: 14px;
        margin-bottom: 40px;
        text-align: left;
        width: 70%;
    }

    .request-appointment-at-invite > .text-area-wrapper > .text-area-label {
        font-size: 14px;
        margin-bottom: 10px;
        display: block;
    }
</style>
